
import { defineComponent } from "vue";
import { VOverlay } from "vuetify/lib";

export default defineComponent({
  mixins: [VOverlay],
  props: {
    color: {
      type: String,
      default: "ltk-black",
    },
  },
});
